<i18n>
{
  "cl":{
    "active": "Activo",
    "inactive": "Inactivo",
    "button-manage":"Ver",
    "not-avaliable-data": "No disponible",
    "idNumber": "Rut",
    "status": "Estado"
  },
  "pe":{
    "active": "Activo",
    "inactive": "Inactivo",
    "button-manage":"Ver",
    "not-avaliable-data": "No disponible",
    "idNumber": "DNI/CE",
    "status": "Estado"
  },
  "br":{
    "active": "Ativo",
    "inactive": "Inativo",
    "button-manage":"Ver",
    "not-avaliable-data": "Não disponível",
    "idNumber": "CPF/CNPJ",
    "status": "Status",
    "simulator-front-end": "Simulador"
  }
}
</i18n>
<template>
  <div class="container">
    <div class="default-item">
      <div
        v-for="broker in brokersList"
        :key="broker._id"
        class="card-item shadowless has-text-centered default-item-info med-size-text my-3">
        <div class="items-alignment">
          <span class="default-item-name content-title">
            {{ broker.name || $t("not-avaliable-data") }}
          </span>
          <span v-if="broker.brokerSource.origin !== 'commercial-manager'" class="prospect-broker-tag creditu-tag">
            {{ broker.brokerSource.name || $t("simulator-front-end") }}
          </span>
        </div>

        <b-tooltip :label="$t('idNumber')" position="is-left">
          <span class="default-item-idnumber">
            <i class="fa-solid fa-address-card has-text-primary" /> {{ broker.idNumber || $t("not-avaliable-data") }}
          </span>
        </b-tooltip>

        <b-tooltip :label="$t('status')" position="is-left">
          <span class="default-item-status">
            <i class="fa-solid fa-user-tie has-text-primary" />
            {{ (broker.status && broker.status === "ACTIVE" ? $t("active") : $t("inactive")) || $t("not-avaliable-data") }}
          </span>
        </b-tooltip>

        <span class="default-item-prospects ">
          <i class="fa-solid fa-users has-text-primary" />
          Leads: {{ broker.prospectsList ? broker.prospectsList.length : 0 }}
        </span>

        <button
          :id="`broker-${broker._id}`"
          class="button manage-button is-button-secondary is-rounded is-fullwidth-mobile"
          @click="goToSingleBrokerView(broker._id)">
          <span>
            {{ $t('button-manage') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrokersList',
  props: {
    brokersList: { type: Array, require: true },
    userIsBroker: { type: Boolean, optional: false }
  },
  methods: {
    goToSingleBrokerView(brokerId) {
    // Es true porque para llegar a esta componente debe ser broker multiple
      this.$store.state.brokersModule.userIsBroker = this.userIsBroker;
      this.$store.state.brokersModule.brokerIsMultiple = true;
      this.$router.push(`broker/${brokerId}`);
    }
  }
};
</script>

<style scoped>
.default-item-status {
  text-transform: capitalize;
}
.items-alignment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.creditu-tag {
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  padding: 0px 10px;
  text-align: center;
}
.prospect-broker-tag{
  background: var(--primary);
  color: #fff;
}
</style>
